<template>
  <button type="button" class="btn_focus_menu" @click="goRoadMap">IT 로드맵</button>
</template>

<script>
export default {
  name: 'RoadMapButton',
  props: {

  },
  data () {
    return {
      eduGrpCd: '',
      roadMapMenuSno: '274',
      roadMapmenuInfo: {}
    }
  },
  computed: {

  },
  created () {
    let promoStore = window.vue.getStore('promoInfo')
    this.eduGrpCd = promoStore.state.promoInfo.eduGroupCode

    this.getRoadMapInfo()
  },
  mounted () {

  },
  methods: {
    getRoadMapInfo () {
      this.fetchData('selectMobileMenu', { eduGrpCd: this.eduGrpCd, menuTyp: 'MW_MAIN', siteMenuSno: this.roadMapMenuSno }, (data) => {
        this.roadMapmenuInfo = data.menuList && data.menuList.length > 0 ? data.menuList[0] : {}
      })
    },
    goRoadMap () {
      if (Object.keys(this.roadMapmenuInfo).length > 0) {
        this.goMenuLink(this.roadMapmenuInfo)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/common/RoadMapButton.vue